import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

import {
  toolTipInformation,
  useFormatDates,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BaseShift/ShiftLayout/ShiftDetails/utils'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Shift } from 'modules/shift_management/lib/types'

interface Props {
  shift: Shift
  date: moment.Moment
}

const Full = ({ shift, date }: Props) => {
  const [{ view, shiftsConflicts }] = useSchedule()
  const formatDates = useFormatDates()

  const inRange = shift.inRange(view.firstDay, view.lastDay)
  const nightShiftPeriodBefore = shift.isNightShift && !inRange
  const nightShiftCurrentWeek = shift.isNightShift && inRange
  const showPlusOne =
    nightShiftCurrentWeek && !shift.isOvernightByCalendarDay && !shift.isAnHourOrLessLong
  const showConflictsIcon = view.isByAreas && shiftsConflicts.has(shift.id)
  const conflictInformation = toolTipInformation({ shift, shiftsConflicts })
  const dates = formatDates(shift, date, nightShiftPeriodBefore)

  return (
    <Box flexDirection="row" gap="s4" alignItems="center">
      <Text.Normal size="100" weight="medium" color="grey1000">
        {dates.startAt} - {dates.endAt}
      </Text.Normal>
      {showConflictsIcon && (
        <Box height="full" justifyContent="center" padding="s2">
          <InformationTooltip information={conflictInformation} color="grey1000" />
        </Box>
      )}
      {!showConflictsIcon && showPlusOne && (
        <Text.Normal size="100" color="grey1000">
          {i18n.t('shift_management.plus_1_day_tag')}
        </Text.Normal>
      )}
    </Box>
  )
}

export default observer(Full)
